/**
 * @deprecated
 */
export const checkHasLength = (
  potentialArray: Array<unknown> | undefined | null
): boolean => {
  return (Array.isArray(potentialArray) && potentialArray.length > 0) || false;
};
